export default function ImpersonationBanner() {
  const visible =
    typeof window !== "undefined" &&
    localStorage.getItem("isImpersonating") === "true";

  if (!visible) return null;

  const stopImpersonation = () => {
    localStorage.removeItem("isImpersonating");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("refreshToken");

    if (
      import.meta.env.VITE_ENV !== undefined &&
      import.meta.env.VITE_ENV !== "prod"
    ) {
      window.location.href = "https://admin.dev.verdeo.fr/project-leaders";
    } else if (import.meta.env.VITE_ENV == undefined) {
      window.location.href = "http://verdeo.admin/project-leaders";
    } else {
      window.location.href = "https://admin.verdeo.fr/project-leaders";
    }
  };

  return (
    <div
      style={{
        background: "#B91C1C",
        color: "white",
        padding: "8px 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: 500,
      }}
    >
      <span className="mr-2"> ⚠️ Mode admin actif</span>

      <button
        onClick={stopImpersonation}
        style={{
          background: "white",
          color: "#B91C1C",
          border: "none",
          padding: "4px 10px",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        Quitter
      </button>
    </div>
  );
}
